<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Master TV Program 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Program Code</span></b-input-group-prepend>
                <b-form-input v-model="tblData.kode" placeholder="use % for wildcard"></b-form-input>
                <b-form-input v-model="tblData.nama" placeholder="Program name" style="width:40% !important;"  class="ml-1"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="7">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Program Group</span></b-input-group-prepend>
                <b-form-select v-model="tblData.groupprog" :plain="true" :options="filtergroups"></b-form-select>
                <b-input-group-prepend><span class="pt-2 mr-2">Department</span></b-input-group-prepend>
                <b-form-input v-model="tblData.newscateg" ></b-form-input>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked" :key="tblData.limit"
      >
        <template v-slot:cell(news)="data">
          {{ data.item.newscateg}} {{ data.item.newsdep}}        
        </template>
        <template v-slot:cell(blocking)="data">
          <span v-if="(data.item.blocking)">BLOCKING</span>
          <span v-else>NON BLOCKING</span>
        </template>
        <template v-slot:cell(studio)="data">
          <span v-if="(data.item.studiolive)">{{ data.item.studiolivename}}</span>
          <span v-else>{{ data.item.studiotapename}}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row >
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">TV Program - Add/Edit Form 
          </div>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Name</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.nama" :state="!$v.frmdata.nama.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Code</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.kode"  v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                        <b-input-group-prepend><span class="p-2">BMS Code</span></b-input-group-prepend>
                        <b-form-input v-model="frmdata.idbms" ></b-form-input>
                        <!-- <b-input-group-append><span class="input-group-text">Empty for Auto Numbering</span></b-input-group-append> -->
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Group</label></b-input-group-prepend>
                        <b-form-select style=" width: 50%;"  v-model="frmdata.groupprog" :plain="true" :options="groups" :state="!$v.frmdata.groupprog.$error"></b-form-select>
                        <b-input-group-prepend><span  class="pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;Rate Spot</span></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.spotrate" :plain="true" :options="spotrates" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Product Type</label></b-input-group-prepend>
                        <b-form-select style=" width: 50%;"  v-model="frmdata.progtype" :plain="true" :options="progtypes" ></b-form-select>
                        <b-input-group-prepend><span  class="pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;Rate Spot</span></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.spotrate" :plain="true" :options="spotrates" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>News Category/Dep</label></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.newscateg" :plain="true" :options="newscategs" ></b-form-select>
                        <b-form-select class="ml-1" v-model="frmdata.newsdep" :plain="true" :options="newsdeps" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>LIVE Production</label></b-input-group-prepend>
                      <b-form-select  v-model="frmdata.studiolive" :plain="true" :options="studiolives" ></b-form-select>
                        <b-input-group-append>
                                <span class="input-group-text">Studio/Equipment Std. Cost</span>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>TAPING Production</label></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.studiotape" :plain="true" :options="studiotapes" ></b-form-select>
                        <b-input-group-append>
                                <span class="input-group-text">Studio/Equipment Std. Cost</span>
                        </b-input-group-append>
                    </b-input-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()"  v-if="saveEnabled" > 
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
        </b-col>
      </b-row>

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import programtv from "../../apis/programtv";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        nama: { required },
        groupprog: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      saveEnabled:true,
      frmdata:{kode:'',nama: '',groupprog:'',newscateg:'' },
      groups:[],newscategs:['','SOFTNEWS','HARDNEWS', 'OFF AIR'],newsdeps:['','MAGAZINE','NEWS GATHERING'], filtergroups:[{value:'', text:'--ALL--'}],
      studiolives:[],studiotapes:[],spotrates:[], progtypes:['','CUSTOMIZE','LOOSE SPOT', 'ROS'],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'nama',
        sortDesc: false
      },
      filter:{ nama:'', groupname:''}
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "kode",
            label: "Program Code",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "nama",
            label: "Program Name",
            sortable: true
          },
          {
            key: "groupname",
            label: "Program Group",
            sortable: true
          },
          {
            key: "progtype",
            label: "type",
            sortable: true
          },
          {
            key: "news",
            label: "News Category/Dep",
            sortable: true
          },
          {
            key: "studio",
            label: "Std.Cost Studio&Equipment",
            sortable: true
          },
          {
            key: "blocking",
            label: "Blocking",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "spotrate",
            label: "Rate Spot",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function () {
      try {
        const [a,b,c] = await Promise.all([
          crud.list({
            tablename:'programtv-group',
            page: 1,
            limit: 1000,
            total: 0,
            sortBy: 'seqno',
            sortDesc: false
          }),
          crud.list({
            tablename:'vwstudiorate',
            page: 1,
            limit: 1000,
            total: 0,
            sortBy: 'studioname',
            sortDesc: false
          }),
          crud.list({
            tablename:'programrate',
            page: 1,
            limit: 1000,
            total: 0,
            sortBy: 'seqno',
            sortDesc: false
          })                    
          ]);
        this.groups = a.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[]);
        // this.filtergroups = a.reduce((newArr,item) =>{
        //     newArr.push({ value: item.kode, text: item.nama});
        //     return newArr;
        // },[{value:'', text:'--ALL--'}]);
        this.filtergroups=this.filtergroups.concat(this.groups);
        this.studiolives = b.reduce((newArr,item) =>{
            if (item.liveprod==1){
              newArr.push({ value: item.studiocode, text: item.studioname});
            }
            return newArr;
        },[{value:'',text:''}]);
        this.studiotapes = b.reduce((newArr,item) =>{
            if (item.liveprod==0){
              newArr.push({ value: item.studiocode, text: item.studioname});
            }
            return newArr;
        },[{value:'',text:''}]);
        this.spotrates = c.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[{value:'',text:''}]);
        
      } catch (error) {
        if (error.message) {
            toastr.error(error.message);
        } else {
            toastr.error(JSON.stringify(error));
        }                      
      }
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // this.tblData.customQuery='';
      // let str = '';
      // if (this.filter.nama){
      //   str = 'nama=%' + encodeURIComponent(this.filter.nama)+'%';
      // }
      // if (this.filter.groupname){
      //   str += str ? '&' : '';
      //   str = str + 'groupprog=' + encodeURIComponent(this.filter.groupname);
      // }
      // this.tblData.customQuery=str;

      const list = await programtv.list(this.tblData);      
      return list;
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },     
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.nama= '';
        this.tblData.groupprog= '';
        this.tblData.newscateg= '';
        this.refresh();
    },

    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.frmdata.frmmode='add';
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.kode;
      this.frmdata.frmmode='edit';
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
        this.saveEnabled=false;
        if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
              this.saveEnabled=true;
        } else {
           
            try {
              // await programtv.save(this.frmdata)
              const hasil= await programtv.save(this.frmdata);
              toastr.success(`Success, Number ${hasil.kode}`, "Save Program",10000);

              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
                      this.saveEnabled=true;
            } catch (error) {
                      this.saveEnabled=true;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await programtv.remove(this.model);//
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
